export const styles = theme => ({
  errorMessage: {
    color: theme.palette.primary.darkRed,
    textTransform: 'uppercase',
  },
  warningMessage: {
    color: theme.palette.primary.warning,
    textTransform: 'uppercase',
  },
});
